<template>
    <div class="windows">
      <div class="container" style="margin-top: 20px;">
        <!-- 这一坨是说明你会学到什么 和 试听课 -->
        <div class="row">
          <div class="col-8" >
            <img src="../../assets/kcimg/studyed-title.png" alt="" width="120px">
            <div style="background-color:#F5F9F9; min-height: 100px; height: auto; border-radius: 10px; margin-top: 15px;" >
              <div class="container" style="padding: 20px; font-size: 14px; font-weight: 600; min-height: 100px; height: auto;">
                <div class="row g">

                  <div class="col-6" v-for="(item, index) in list" :key="index">
                    <div class="p-3"><li>{{ item }}</li></div>
                  </div>

                </div>
              </div>
            </div>
          </div>
          <div class="col-4" style="font-size:16px;">
            <div class="col text-center" style=""> 
              <div style="background-color:#162E3E; width: 70%; margin: 20px auto 0px; height: 150px; box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1)">
                <img @click="clickMeToVideo" style="cursor: pointer;" src="../../assets/kcimg/ds.png" alt="" width="40%">
                <div style="text-align: center; color: white; font-weight: 600; cursor: pointer;" @click="clickMeToVideo">试看本节课</div>
              </div> 
              <div style="background-color:white; width: 70%; margin: 0px auto; height: 40px;  box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04)">
                <span style="line-height: 40px;">1-1导学</span>
              </div> 
              <el-button v-if="isShow && state === '已购买'" type="primary" style="margin-top: 10px;">已购课程</el-button>
              <el-button v-else type="warning" style="margin-top: 10px;" @click="clickMeToOrder">购买课程</el-button>
            </div>
          </div>
        </div>
        <!-- 这一坨是课程的简介 -->
        <div class="row" style="padding-top: 10px;">
          <div class="col">
            <img src="../../assets/kcimg/course-desc-title.png" alt="" width="120px">
            <div style="font-size: 15px; padding: 25px; color:#303133;">
              {{ courseAbout }}
            </div>
          </div>
        </div>
        <!-- 这一坨是课程目录 -->
        <!-- <div class="row">
            
            <div class="col-12">
              <img src="../../assets/kcimg/catalogue-title.png" alt="" width="120px" style="margin-bottom: 20px;">
                <div class="row">
                    <div class="accordion" id="accordionPanelsStayOpenExample">
                        <div class="accordion-item" v-for="(item, index) in catalog" :key="index">
                            <h2 class="accordion-header">
                                <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" 
                                :data-bs-target="'#c' + item.id" aria-expanded="false" 
                                :aria-controls="'c' + item.id" style="font-size: 16px;">
                                    {{ item.title }}
                                </button>
                                
                            </h2>
                            <div :id="'c' + item.id" class="accordion-collapse collapse">
                                <div class="accordion-body col-12" style="font-size: 14px;">
                                    <div class="row">
                                        <div class="col-10" style="font-size: 14px;">
                                            {{ item.content }}
                                            {{ item.number }}
                                        </div>
                                        <div class="col-2" style="display: flex; align-content: center; align-items: center; justify-content: center;">
                                          去看视频
                                        </div>
                                        <div class="col-12">
                                          <el-divider>习题</el-divider>
                                        </div>
                                        <div class="col-11" style="font-size: 14px; margin-top: 5px; margin: 0 auto;">
                                          <table class="table table-hover">
                                            <tbody>
                                              <tr>
                                                <th scope="row">1</th>
                                                <td>Mark</td>
                                                <td>Otto</td>
                                                <td>@mdo</td>
                                              </tr>
                                              <tr>
                                                <th scope="row">2</th>
                                                <td>Jacob</td>
                                                <td>Thornton</td>
                                                <td>@fat</td>
                                              </tr>
                                              <tr>
                                                <th scope="row">3</th>
                                                <td colspan="2">Larry the Bird</td>
                                                <td>@twitter</td>
                                              </tr>
                                            </tbody>
                                          </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div> -->
        <Catalog ref="son" v-if="isOpen" :videoInfo="videoInfo"></Catalog>
      </div>
    </div>
</template>

<script>
  //引入boostrap 样式 和 js
  import Url from '@/constant/Url';
  import Catalog from './Catalog.vue'
  import $ from "jquery"
  export default {
    name:'Programmes',
    components: {
      Catalog,
    },
    data() {
      return {
        isShow: false,
        courseAbout:'',
        words:'',
        list:'',

        catalog:[],
        catalogId:'',
        courseVideo:[],

        state:"未购买",
        videoInfo:{},
        isOpen: false,
      };
    },
    watch: {
      words: {
        deep:true,
        immediate:true,
        handler(value) {
          this.list = value.split('&')
        }
      },
    },
    mounted() {
      const vue = this
      const route = this.$route

      if (this.$store.state.me.id !== "") this.readOrder()
      else {
          const t = setInterval(() => {
              if (this.$store.state.me.id !== "") {
                  this.readOrder()
                  clearInterval(t); // 清除定时器
              }
          }, 100);
      }

      $.ajax({
        url:'https://app6132.acapp.acwing.com.cn/api/course/read/one/',
        type:'get',
        data: {
          id:route.params.id
        },
        success(resp) {
          if (resp.error_message === 'success') {
            console.log("course == >", resp.course)
            const course = JSON.parse(resp.course)
            vue.courseAbout = course.courseAbout
            vue.words = course.words
            vue.GetCatalog()
          } else {
            console.log("获取课程信息失败了, resp == >", resp.error_message)
          }
        },
        error(resp) {
          console.log("获取课程信息彻底失败了, resp == >", resp.error_message)
        }
      })
    },
    methods: {
      readOrder() { // 获取订单
        const vue = this
        const route = this.$route
        const store = this.$store
        $.ajax({
          url: Url.rOrderUrl,
          type: 'post',
          headers: {
            Authorization: "Bearer " + store.state.me.token
          },
          data: {
            courseId: route.params.id
          },
          success(resp) {
            if (resp.error_message === "success") {
              vue.state = JSON.parse(resp.order).state
              vue.videoInfo = JSON.parse(resp.order)
              vue.isShow = true
              vue.isOpen = true
            } else {
              vue.isOpen = true
            }
          },
          error() {
            vue.isOpen = true
          }
        })
      },
      ReadCourseVideo(catalogId) { // 获取第一个课程视频
        const vue = this
        const store = this.$store

        $.ajax({
            url: Url.rCourseVideoUrl,
            type:'post',
            headers: {
                Authorization: "Bearer " + store.state.me.token,
            },
            data: {
                catalogId: catalogId, // 目录id
            },
            success(resp) {
                if (resp.error_message === "success") {
                    vue.courseVideo = JSON.parse(resp.list)
                    console.log("list == >", vue.courseVideo)
                } 
            },
            error(resp) {
                console.log("获取课程视频彻底失败了, resp == >", resp)
            }
        })
      },
      GetCatalog() { // 获取所有目录 
          const vue = this
          const store = this.$store
          const route = this.$route

          $.ajax({
              url:'https://app6132.acapp.acwing.com.cn/api/catalog/read/list/',
              type:'post',
              data: {
                  courseId: route.params.id,
              },
              success(resp) {
                  if (resp.error_message === "success") {
                      vue.catalog = JSON.parse(resp.List)
                      vue.ReadCourseVideo(vue.catalog[0].id)
                  } 
              },
              error(resp) {
                  console.log("获取目录彻底失败了, resp == >", resp)
              }
          })
      },
      clickMeToVideo() { // 去第一个视频页面 
        this.$router.push({
          path:`/programmes/videoing/${this.$route.params.id}/${this.catalog[0].id}/${this.courseVideo[0].id}`,
          params: {
            id: this.$route.params.id,
            catalogId: this.$refs.son.catalog[0].id, 
            Vid: this.courseVideo[0].id, 
          }
        })
        window.location.reload() // 刷新一下页面捏
      },
      clickMeToOrder() { // 去订单页面
        this.$router.push({
          name:'buy',
          params: {
            id:this.$route.params.id
          }
        })
      }
    }
  }
</script>

<style scoped>
/* 路由样式 */
.windows {
  width: 100%; 
  min-height: 800px;
  height: auto;
}
/* .luyou {
  text-decoration: none; color:black
}
.luyou:hover {
  text-decoration: none;
}
.luyou1:visited {
  color:#409EFF;
} */
/* 路由样式
.el-menu-vertical-demo:not(.el-menu--collapse) {
    width: 200px;
    min-height: 400px;
  }

  .el-header, .el-footer {
    background-color: #B3C0D1;
    color: #333;
    text-align: center;
    line-height: 60px;
  }
  
  .el-aside {
    background-color: #D3DCE6;
    color: #333;
    text-align: center;
    line-height: 200px;
  }
  
  .el-main {
    background-color: #E9EEF3;
    color: #333;
    text-align: center;
    line-height: 160px;
  }
  
  body > .el-container {
    margin-bottom: 40px;
  }
  
  .el-container:nth-child(5) .el-aside,
  .el-container:nth-child(6) .el-aside {
    line-height: 260px;
  }
  
  .el-container:nth-child(7) .el-aside {
    line-height: 320px;
  } */
</style>